var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInboxArchiveLine = function SvgInboxArchiveLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 3.9 21 7.5v11.7a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V7.504L4.8 3.9zm0 5.4H4.8v9h14.4zm-7.2.9 3.6 3.6h-2.7v3.6h-1.8v-3.6H8.4zm6.088-4.5H5.912l-.899 1.8h13.975z"
  })));
};
export default SvgInboxArchiveLine;